import { render, staticRenderFns } from "./content-tabs.vue?vue&type=template&id=076cf3e7"
import script from "./content-tabs.vue?vue&type=script&lang=js"
export * from "./content-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076cf3e7')) {
      api.createRecord('076cf3e7', component.options)
    } else {
      api.reload('076cf3e7', component.options)
    }
    module.hot.accept("./content-tabs.vue?vue&type=template&id=076cf3e7", function () {
      api.rerender('076cf3e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/conversation-dialog/content-tabs.vue"
export default component.exports